import { useTranslation } from 'react-i18next';
import type { RequestStatus, CodeStatus } from '@/config/admin';

const REQUEST_STYLES: Record<RequestStatus, string> = {
  new: 'bg-secondary-100 text-secondary-900',
  registered: 'bg-secondary-100 text-secondary-900',
  code_sent: 'bg-primary-100 text-primary-900',
  awaiting_activation: 'bg-accent-100 text-accent-900',
  activation_validated: 'bg-primary-100 text-primary-900',
  processing: 'bg-primary-100 text-primary-900',
  processed: 'bg-primary-500 text-background-50 dark:text-foreground-950',
  cancelled: 'bg-foreground-100 text-foreground-700',
  expired: 'bg-accent-100 text-accent-900',
};

const CODE_STYLES: Record<CodeStatus, string> = {
  sent: 'bg-primary-100 text-primary-900',
  used: 'bg-primary-500 text-background-50 dark:text-foreground-950',
  invalidated: 'bg-foreground-100 text-foreground-700',
  expired: 'bg-accent-100 text-accent-900',
};

export function RequestStatusBadge({ status }: { status: RequestStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${REQUEST_STYLES[status]}`}
    >
      {t(`admin.status.${status}`)}
    </span>
  );
}

export function CodeStatusBadge({ status }: { status: CodeStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${CODE_STYLES[status]}`}
    >
      {t(`admin.codeStatus.${status}`)}
    </span>
  );
}